import loadADIInvoices from "@NA/Handlers/InvoiceHistory/ADIInvoiceHistoryHandler";
import loadADIMultipleInvoices from "@NA/Handlers/InvoiceHistory/ADIMultipleInvoicesHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadInvoices from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoices";
import {
    getInvoicesDataView,
    InvoicesDataViewContext,
} from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/UpdateSearchFields";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import qs from "qs";
import * as React from "react";
import { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    settings: getSettingsCollection(state),
    getInvoicesParameter: state.pages.invoiceHistory.getInvoicesParameter,
    invoicesDataView: getInvoicesDataView(state, state.pages.invoiceHistory.getInvoicesParameter),
    location: getLocation(state),
    getADIInvoiceParameter: state.ADIGlobalData.ADIInvoiceStore.loadInvoiceParameters,
    invoiceLoading: state.ADIGlobalData.ADIInvoiceStore.isLoading,
    invoiceData: state.ADIGlobalData.ADIInvoiceStore.invoiceResults,
    changeCustomerLoading: state.ADIGlobalData.ADIBillToStore.isLoading,
    userRoles: state.ADIGlobalData.ADIUserRoleStore,
    showInvoices: state.context.settings.settingsCollection.maNavSettingSettings.showInvoices

});

const mapDispatchToProps = {
    loadInvoices,
    updateSearchFields,
    loadADIInvoices,
};

export interface InvoiceHistoryPageStyles {
    loadingOverlay?: LoadingOverlayProps;
    mainContainer?: InjectableCss;
    lowerContainer?: InjectableCss;
}

export const styles: InvoiceHistoryPageStyles = {
    loadingOverlay: {
        css: css`
            & > div:first-child[data-loading="true"] {
                position: fixed;
            }
        `,
    },
    mainContainer: {
        css: css`
            font-size: 20px;
            line-height: 25px;
            color: #000;
            font-weight: 400;
            margin-bottom: 10px;
        `,
    },
    lowerContainer: {
        css: css`
            font-size: 16px;
            line-height: 24px;
            color: #000;
            font-weight: 400;
        `,
    },
}

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const InvoiceHistoryPage = ({
    settings,
    updateSearchFields,
    loadInvoices,
    id,
    invoicesDataView,
    history,
    location,
    getInvoicesParameter,
    getADIInvoiceParameter,
    loadADIInvoices,
    invoiceData,
    invoiceLoading,
    changeCustomerLoading,
    userRoles,
    showInvoices
}: Props) => {
    let firstLoad = false;
    // useEffect(() => {
    //     firstLoad = true;
    //     const pageSizeCookie = getCookie("InvoiceHistory-PageSize");
    //     const pageSize = pageSizeCookie ? parseInt(pageSizeCookie, 10) : undefined;
    //     if (location.search) {
    //         const getInvoicesApiParameter = parseQueryString<GetInvoicesApiParameter>(location.search);
    //         if (pageSize) {
    //             getInvoicesApiParameter.pageSize = pageSize;
    //         }
    //         updateSearchFields({ ...getInvoicesApiParameter, type: "Replace" });
    //     } else if (settings.invoiceSettings.lookBackDays > 0) {
    //         const tzOffset = new Date().getTimezoneOffset() * 60000;
    //         const fromDate = new Date(
    //             Date.now() - settings.invoiceSettings.lookBackDays * 60 * 60 * 24 * 1000 - tzOffset,
    //         );
    //         updateSearchFields({ fromDate: fromDate.toISOString().split("T")[0], type: "Initialize", pageSize });
    //     }
    // }, []);

    // useEffect(() => {
    //     if (!firstLoad) {
    //         const queryString = qs.stringify(getInvoicesParameter);
    //         history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
    //     }
    // }, [getInvoicesParameter]);

    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!invoiceData && !invoiceLoading) {
            loadADIInvoices(getADIInvoiceParameter);
        }
    });
 
    // Commented the below code as not using. Please remove this really doesn't needed.
    // const isInvoiceAccess = ((userRoles.fullAccess || userRoles.limitedAccess) && userRoles.accounting) || userRoles.employee;
    return (
        <Page>
            <InvoicesDataViewContext.Provider value={invoicesDataView}>
                <LoadingOverlay {...styles.loadingOverlay} loading={invoiceLoading || changeCustomerLoading}>
                    {showInvoices ? (
                        <Zone contentId={id} zoneName="Content" />
                    ) : (
                        <>
                                 <StyledWrapper as="h2" {...styles.mainContainer}>
                                     {"Unauthorized Access"}
                                 </StyledWrapper>
                                 <StyledWrapper {...styles.lowerContainer}>
                                     {"We're sorry. You do not have permissions to view the page you are trying to visit."}
                                 </StyledWrapper>
                             </>
                    )}
                </LoadingOverlay>
            </InvoicesDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(InvoiceHistoryPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

export const InvoiceHistoryPageContext = "InvoiceHistoryPage";
